
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.5 16H3.5C2.67 16 2 16.67 2 17.5C2 18.33 2.67 19 3.5 19H15.5C16.33 19 17 18.33 17 17.5C17 16.67 16.33 16 15.5 16ZM18.85 7.72997C19.47 7.11997 19.85 6.27997 19.85 5.34997C19.85 3.83997 18.85 2.55997 17.47 2.13997C16.99 1.99997 16.5 2.35997 16.5 2.85997C16.5 3.18997 16.71 3.47997 17.02 3.56997C17.79 3.79997 18.35 4.50997 18.35 5.34997C18.35 6.16997 17.82 6.85997 17.08 7.10997C16.75 7.21997 16.5 7.49997 16.5 7.84997V7.99997C16.5 8.36997 16.77 8.68997 17.14 8.74997C19.07 9.05997 20.5 10.75 20.5 12.77V14.25C20.5 14.66 20.84 15 21.25 15C21.66 15 22 14.66 22 14.25V12.76C22 10.54 20.72 8.61997 18.85 7.72997ZM16.03 10.2H14.73C13.71 10.2 12.79 9.46997 12.66 8.44997C12.54 7.49997 13.12 6.74997 13.96 6.51997C14.28 6.42997 14.5 6.13997 14.5 5.79997C14.5 5.30997 14.04 4.93997 13.57 5.07997C12.15 5.48997 11.12 6.80997 11.15 8.35997C11.18 10.2 12.77 11.65 14.61 11.65H16.03C17.08 11.65 18 12.39 18 13.7V14.25C18 14.66 18.33 15 18.75 15H18.76C19.17 15 19.51 14.67 19.51 14.25V13.36C19.5 11.55 17.9 10.2 16.03 10.2ZM18 16H19.5V19H18V16ZM20.5 16H22V19H20.5V16Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-smoking-rooms`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSmokingRooms

    ```js
    <b-new-b-icon-smoking-rooms />
    ```
</docs>


